import { AccountSiteObject } from '../administration/accountSiteObject';
import { EntityAddress } from '../administration/entityAddress';
import { EntityContact } from '../administration/entityContact';
import { UserSummary } from '../administration/user';
import { AddressSummary } from './address';
import { CustomerContract } from './customerContract';
import { CustomerType } from './customerType';
import { EntityTruck } from './entityTruck';

export class CustomerListing {
    id: number;
    code: string;
    name: string;
    site?: any;
    siteId?: number;
}

export class CustomerSummary extends CustomerListing {
    notes: string;
    entityAddress: EntityAddress;
    entityContact: EntityContact;
    customerContract: CustomerContract;
    entityTruck: EntityTruck;
    customerType: CustomerType;
    customerSites: AccountSiteObject[];
    addressIds: number[];
    updatedUser: UserSummary;
    createdUser: UserSummary;
    createdOn: Date;
    lastUpdatedOn: Date;
    customerShipToAddresses:ICustomerShipToAddresses[];

}
export interface ICustomerShipToAddresses{
  customerId:number;
  customer:CustomerSummary;
  addressId:number;
  address:AddressSummary;
}
export class CustomersListingWithEntityAddressDto {
  id: number;
  code: string;
  entityAddress: EntityAddress;
}
